$(document).ready(function () {
	$("body").removeClass("preload");
	svg4everybody();

	// home slider
	mainSlider();

	// init afisha carousel tabs
	init_carousel_tabs(".carousel-tabs");

	// promo slider
	promo_slider();
	scrolling_banners();

	/*--------------------------------------------------------------
   # code
   --------------------------------------------------------------*/

	// footer menu expand
	$(document).on("click", ".fm_expand", function () {
		var _ = $(this);
		if (_.hasClass("active")) {
			$(".fm_col__body").slideUp(150);
			$(".fm_expand").removeClass("active");
		} else {
			$(".fm_col__body").slideUp(150);
			$(".fm_expand").removeClass("active");
			_.addClass("active");
			_.parents(".fm_col").find(".fm_col__body").slideDown(150);
		}
	});

	// dropdown
	$(document).on("click", ".dd__current", function () {
		var _ = $(this);
		var dropdown = _.parent();

		if (dropdown.hasClass("active")) {
			$(".dd").removeClass("active");
		} else {
			$(".dd").removeClass("active");
			dropdown.addClass("active");
		}
	});
	$(document).on("click", ".dd li", function () {
		var _ = $(this);
		var current = _.parents(".dd").find(".dd__current span");
		current.text(_.text());
		$(".dd").removeClass("active");
	});
	$(document).on("click", function (e) {
		if ($(e.target).closest(".dd").length === 0) {
			$(".dd").removeClass("active");
		}
		if ($(e.target).closest(".filter-date").length === 0) {
			$(".filter-date").removeClass("active");
		}
	});

	// datepicker
	$(".filter-datepicker").datepicker({
		minDate: new Date(),
	});
	$(".filter-datepicker-ver-2").datepicker({
		minDate: new Date(),
		classes: "ver-2",
		prevHtml: "<div></div>",
		nextHtml: "<div></div>",
		position: "bottom left",
		navTitles: {
			days: "MM",
		},
	});
	$(".filter-datepicker-ver-2.right-bottom").datepicker({
		minDate: new Date(),
		classes: "ver-2",
		prevHtml: "<div></div>",
		nextHtml: "<div></div>",
		position: "bottom right",
		navTitles: {
			days: "MM",
		},
	});

	$(document).on("click", ".filter-date", function () {
		$(this).addClass("active");
	});

	// sync-slider
	$(".sync-slider").slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		rows: 0,
		prevArrow: prevArrow("keyboard-right"),
		nextArrow: nextArrow("keyboard-right"),
		asNavFor: ".sync-nav",
	});
	$(".sync-nav").slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		arrows: false,
		rows: 0,
		asNavFor: ".sync-slider",
		// centerMode: true,
		focusOnSelect: true,
	});

	// show password
	$(".password-input").on("click", ".password-input__btn", function () {
		var input = $(this).parent().find("input");
		if (input.attr("type") === "password") {
			$(this).addClass("active");
			input.attr("type", "text");
		} else {
			$(this).removeClass("active");
			input.attr("type", "password");
		}
	});

	// switch auth popup
	$(".auth_switch").on("click", function (e) {
		e.preventDefault();

		$(".auth-form").hide();
		$($(this).attr("href")).fadeIn(200);
	});

	window.afishaTextWrap = function () {
		if ($(window).outerWidth() > 1200) {
			$(".afisha-item").hover(
				function () {
					$(this)
						.find(".afisha-item__hidden")
						.prepend($(this).find(".afisha-item__text"));
				},
				function () {
					$(this)
						.find(".afisha-item__content")
						.prepend($(this).find(".afisha-item__text"));
				}
			);
		}
	};

	afishaTextWrap();

	$(".popup-youtube").magnificPopup({
		type: "iframe",
		removalDelay: 300,
		mainClass: "mfp-zoom-in",
		callbacks: mp_callbacks,
	});

	$(".acc-item.active .acc-item__body").show();
	$(".acc-item").on("click", ".acc-item__title", function () {
		const parent = $(this).parent();
		const body = parent.find(".acc-item__body");
		if (!parent.hasClass("active")) {
			$(".acc-item").removeClass("active");
			$(".acc-item__body").slideUp(150);
			parent.addClass("active");
			body.slideDown(150);
		} else {
			$(".acc-item").removeClass("active");
			$(".acc-item__body").slideUp(150);
		}
	});

	// filter list
	$(".js-filter-input").each(function () {
		const $field = $(this);
		$(this).on("keyup", function () {
			const val = $(this).val().toLowerCase();
			$field
				.parent()
				.find(".place-item")
				.each(function () {
					if ($(this).text().toLowerCase().indexOf(val) !== -1) {
						$(this).show();
					} else {
						$(this).hide();
					}
				});
		});
	});

	// init google map
	if (document.getElementById("map")) {
		new google.maps.Map(document.getElementById("map"), {
			center: { lng: 30.462069, lat: 50.430764 },
			zoom: 6,
		});
	}

	$(".carousel-x4").slick({
		rows: 0,
		slidesToShow: 4,
		slidesToScroll: 1,
		// autoplay: true,
		prevArrow: prevArrow("keyboard-right"),
		nextArrow: nextArrow("keyboard-right"),
		responsive: [
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 2,
				},
			},
		],
	});

	//start of header locations logic
	class LocationLinks {
		constructor() {
			this.locationBtnActive = false;
			this.selectedCountry = $("#country-select").data("selected");
			this.selectedCity = "";

			this.countryInput = $("#country-select");
			this.countryInputMobile = $("#country-select-mobile");
			this.options = [...$(".location-menu__select-city option")];
			this.cityInputDesktop = $("#city-select");
			this.cityInputMobile = $("#city-select-mobile");
			this.changeLocationBtns = $(".location-menu__btn");
			this.locationHeaderButton = $(".location-menu__header, .m-city-select");
			this.locationDropdown = $(".location-menu");

			this.countrySelect = new TomSelect(this.countryInput, {
				allowEmptyOption: true,
				create: false,
				controlInput: null,
				preload: true,
				render: {
					option: function (data, escape) {
						return `<div><div class="option__inner ${data.img ? "img img-" + data.img : ""
							}">${escape(data.text)}</div></div>`;
					},
					item: function (data, escape) {
						return `<div class="option__inner ${data.img ? "img  img-" + data.img : ""
							}">${escape(data.text)}</div>`;
					},
				},
			});

			this.citySelect = new TomSelect(this.cityInputDesktop, {
				allowEmptyOption: true,
				create: true,
				controlInput: null,
				preload: true,
				render: {
					option: function (data, escape) {
						return `<div><div class="option__inner ${data.img ? "img img-" + data.img : ""
							}">${escape(data.text)}</div></div>`;
					},
					item: function (data, escape) {
						return `<div class="option__inner ${data.img ? "img  img-" + data.img : ""
							}">${escape(data.text)}</div>`;
					},
				},
			});

			this.updateInputs();
			this.addOptionAll();
			this.eventListeners();
		}
		addOptionAll() {
			var countryDefaultText = $("#country-select").data('default-text');
			this.countrySelect.addOption({ value: "all", text: countryDefaultText, $order: -1 });

			this.citySelect.on('dropdown_open', () => {
				if (this.selectedCountry == 'all') {

					[...document.querySelectorAll('[aria-disabled="true"]')].forEach((i, index) => {
						if (index != 0) {
							i.removeAttribute('aria-disabled');
							i.removeAttribute('data-disabled');
							i.setAttribute('data-selectable', true);
							i.classList.add('is-active');

						}

					});
				};
			})
		};

		updateInputs() {
			const selectedCountry = this.countrySelect.items[0];
			console.log(this.citySelect)

			for (let option in this.citySelect.options) {
				this.citySelect.options[option].disabled =
					this.citySelect.options[option].country != selectedCountry;
			}

			this.citySelect.clearCache();
		}

		handleCountryChange(e) {
			this.selectedCountry = e.target.value;

			if (this.selectedCountry === 'all') {
				this.citySelect.clear();
				this.updateInputs();
			} else {
				this.citySelect.clear();
				this.updateInputs();
			}
		}

		handleCityChange = (e) => {
			this.selectedCity = e.target.value;

			this.cityInputDesktop.val(this.selectedCity);
			this.cityInputMobile.val(this.selectedCity);
		};

		changeLocation = () => {
			if (this.selectedCity) {
				window.location.href = this.selectedCity;
			}
		};

		toggleCountrySwitcher = () => {
			this.locationBtnActive = !this.locationBtnActive;
			const locationModal = document.querySelector(".location-menu__modal");

			if (this.locationBtnActive) {
				[...this.locationDropdown, ...this.locationHeaderButton].forEach(
					(dropdown) => {
						locationModal.classList.add("active");
						dropdown.classList.add("active");
					}
				);
			} else {
				[...this.locationDropdown, ...this.locationHeaderButton].forEach(
					(dropdown) => {
						locationModal.classList.remove("active");
						dropdown.classList.remove("active");
					}
				);
			}
		};

		locationModalBlur(e) {
			var excludeClasses =
				".location-menu, .m-city-select, .location-menu__modal";
			if ($(e.target).closest(excludeClasses).length > 0) {
				return false;
			}
			if (this.locationBtnActive) {
				this.toggleCountrySwitcher();
			}
		}

		eventListeners() {
			this.countryInput.on("change", this.handleCountryChange.bind(this));
			this.countryInputMobile.on("change", this.handleCountryChange.bind(this));
			this.cityInputDesktop.on("change", this.handleCityChange.bind(this));
			this.cityInputMobile.on("change", this.handleCityChange.bind(this));
			const clearCountryBtn = document.querySelector('#clear-country')
			const clearCityBtn = document.querySelector('#clear-city')

			clearCountryBtn.addEventListener('click', () => {
				this.countrySelect.clear(false)
				clearCountryBtn.style.display = 'none'
				this.citySelect.clear(false)
				clearCityBtn.style.display = 'none'
			})
			clearCityBtn.addEventListener('click', () => {
				this.citySelect.clear(false)
				clearCityBtn.style.display = 'none'
			})

			$(document).on("click", this.locationModalBlur.bind(this));

			[...this.changeLocationBtns].forEach((button) => {
				button.addEventListener("click", this.changeLocation.bind(this));
			});
			[...this.locationHeaderButton].forEach((button) => {
				button.addEventListener("click", this.toggleCountrySwitcher.bind(this));
			});
			this.countrySelect.on("change", () => {
				clearCountryBtn.style.display = 'block'
			});
			this.citySelect.on("change", (value) => {
				this.selectedCity = value;
				clearCityBtn.style.display = 'block'
			});
		}
	}
	new LocationLinks();

	const locationModal = document.querySelector(".location-menu__modal");
	const locationMenu = document.querySelector(".location-menu");

	if (locationModal) {
		const modalPlacement = () => {
			if (window.innerWidth < 768) {
				document.body.append(locationModal);
				locationModal.classList.add("mobile");
			} else {
				locationMenu.append(locationModal);
				locationModal.classList.remove("mobile");
			}
		};

		window.addEventListener("resize", modalPlacement);
		modalPlacement();
	}

	const accordionBtns = document.querySelectorAll(".accordion");
	if (accordionBtns.length) {
		accordionBtns.forEach((accordion) => {
			accordion.querySelector(".accordion__button").onclick = function () {
				accordion.classList.toggle("is-open");

				let content = accordion.querySelector(".accordion__content");

				if (content.style.maxHeight) {
					content.style.maxHeight = null;
				} else {
					content.style.maxHeight = content.scrollHeight + "px";
				}
			};
		});
	}
});

$(document).ready(function () {
	$(".button-month").click(function () {
		$(".dropdown-month a").removeClass("clicked");
		$(".dropdown-month a").children("span").removeClass("clicked");
		$(".arrow").toggleClass("open");
		$(".dropdown-month").toggleClass("open");
	});

	$(".dropdown-month a").click(function () {
		$(".dropdown-month a").removeClass("clicked");
		$(".dropdown-month a").children("span").removeClass("clicked");
		$(this).toggleClass("clicked");
		$(this).children("span").toggleClass("clicked");
	});
});
if (document.querySelector('.promo-line')) {
	const promoLine = document.querySelector('.promo-line');
	const promoLineCloseButton = promoLine.querySelector('.promo-line-close');

	if (localStorage.getItem('promo-line-hide')) {
		promoLine.style.display = 'none';
	}
	promoLineCloseButton.addEventListener('click', () => {
		localStorage.setItem('promo-line-hide', true);
	})
}

if (document.querySelectorAll('.afisha-item')) {
	const afishaItems = document.querySelectorAll('.afisha-item');
	afishaItems.forEach(afisha => {
		afisha.addEventListener('click', (e) => {
			afisha.querySelector('.afisha-item__title a').click();
		})
	})
}
if (document.querySelectorAll('.afisha-item')) {
	const afishaItems = document.querySelectorAll('.afisha-item');

	afishaItems.forEach(afishaItem => {
		const afishaItemPlaces = afishaItem.querySelectorAll('.afisha-item__place li');

		if (afishaItemPlaces.length <= 5 && afishaItem.closest('.afisha-item').querySelector('.afisha-item__more')) {
			afishaItem.closest('.afisha-item').querySelector('.afisha-item__more').classList.add('is-hidden');
		}

		[...afishaItemPlaces].forEach((place, index) => {
			if (index > 4) {
				place.classList.add('is-hidden');
			}
		})
		if (afishaItem.closest('.afisha-item').querySelector('.afisha-item__more')) {
			showMorePlaces = afishaItem.closest('.afisha-item').querySelector('.afisha-item__more');
			showMorePlaces.addEventListener('click', (e) => {
				e.stopPropagation();
				for (let i = 5; i < afishaItemPlaces.length; i++) {
					afishaItemPlaces[i].classList.remove('is-hidden')
				}
			})
		}

	})
}

document.addEventListener("DOMContentLoaded", () => {
	// let locationModal = document.querySelector('.location-menu__modal');
	// let copiedLinkText = document.querySelector('.location-menu__header').innerText;
	// let locationSelect = locationModal.querySelector('select.location-menu__select');
	// let locationButton = locationModal.querySelector('.location-menu__select');
	// let optionAll = document.createElement('option');
	// optionAll.innerText = copiedLinkText;

	// locationButton.addEventListener('click', () => {
	// 	setTimeout(() => {
	// 		locationSelect.appendChild(optionAll)

	// 	}, 1000)
	// })

	if ((location.host[0] === 'm')) {
		let clearButtons = document.querySelectorAll('.location-menu__clear');
		[...clearButtons].forEach(button => {
			button.style.display = "none";
		})
	}
})

const homeSlides = document.querySelectorAll('.home_slider__slide');
if (homeSlides) {
	function changeImgPath() {
		homeSlides.forEach(el => {
			if(el.getAttribute('data-img')) {
				const imgPath = el.getAttribute('data-img');
				el.querySelector('img').setAttribute('src', imgPath);
			}
		})
	}
	if (window.innerWidth < 760) {
		changeImgPath();
	}
	window.addEventListener('resize', () => {
		changeImgPath();
	})
}

const socialLinksMenu = document.querySelectorAll('.b-socials--menu .b-socials__link');
const socialLinksFooter = document.querySelectorAll('.b-socials--footer .b-socials__link');

if (socialLinksMenu || socialLinksFooter) {
	const paths = [
		{
			'all': [
				{
					title: 'facebook',
					url: 'https://www.facebook.com/mticket.global'
				},
				{
					title: 'instagram',
					url: 'https://www.instagram.com/mticket.global/'
				},
				{
					title: 'tiktok',
					url: 'https://www.tiktok.com/@mticket.global'
				},
				{
					title: 'youtube',
					url: 'https://www.youtube.com/@mticket.global'
				},
			],
			'pl': [
				{
					title: 'facebook',
					url: 'https://www.facebook.com/mticket.polska'
				},
				{
					title: 'instagram',
					url: 'https://www.instagram.com/mticket.polska/'
				},
				{
					title: 'tiktok',
					url: 'https://www.tiktok.com/@mticket.global'
				},
				{
					title: 'youtube',
					url: 'https://www.youtube.com/@mticket.global'
				},
			],
			'gb': [
				{
					title: 'facebook',
					url: 'https://www.facebook.com/mticket.gb'
				},
				{
					title: 'instagram',
					url: 'https://www.instagram.com/mticket.gb/'
				},
				{
					title: 'tiktok',
					url: 'https://www.tiktok.com/@mticket.global'
				},
				{
					title: 'youtube',
					url: 'https://www.youtube.com/@mticket.global'
				},
			],
		}
	]

	let subDomen = null;

	for (key in paths[0]) {

		if (location.host.match(key)) {
			subDomen = location.host.match(key)[0];
			break;
		} else {
			subDomen = "all";
		}

	}

	socialLinksMenu.forEach((link, i) => {
		link.href = paths[0][subDomen][i].url
	})

	socialLinksFooter.forEach((link, i) => {
		link.href = paths[0][subDomen][i].url
	})
}